var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"height":"90vh"},attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-col',{staticStyle:{"position":"relative"},attrs:{"cols":"12"}},[_c('loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }